import { items } from '@wg/wows-entities/const';
import { ManagerData } from '~/core/ManagerData';
import { GameRarity } from '~/types/rarity';
import { settings } from './settings';

export const RARITY_ANIMATION_MAP: Partial<Record<GameRarity, IVideo>> = {
    [GameRarity.legendary]: {
        mp4: null,
        webm: `${settings.urls.cdn}armory/rarities/effect_rarity_legendary_v2.webm`,
    },
    [GameRarity.rare]: {
        mp4: null,
        webm: `${settings.urls.cdn}armory/rarities/effect_rarity_rare_v2.webm`,
    },
    [GameRarity.epic]: {
        mp4: null,
        webm: `${settings.urls.cdn}armory/rarities/effect_rarity_epic_v2.webm`,
    },
    [GameRarity.uncommon]: {
        mp4: null,
        webm: `${settings.urls.cdn}armory/rarities/effect_rarity_uncommon_v2.webm`,
    },
};

export const getRarityForItem = (type: string, id: number) => {
    switch (type) {
        case items.VEHICLES: {
            const shipData = ManagerData.getShip(id);
            return shipData?.rarity || null;
        }

        case items.CAMOUFLAGE:
        case items.PERMOFLAGES:
        case items.SKIN:
        case items.MSKIN:
        case items.STYLE:
        case items.SHIP_DESTRUCTION: {
            const itemData = ManagerData.getItem(id);
            return itemData?.rarity || null;
        }
    }

    return null;
};
